"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
exports.fromUtf8 = fromUtf8;
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}
exports.toUtf8 = toUtf8;
//# sourceMappingURL=whatwgEncodingApi.js.map